<template>
  <DynamicModal
    :showModal="showRevenueDetailsModal"
    :persistent="false"
    @clickOutside="closeModal"
    title="Revenue"
    maxWidth="800px"
  >
    <v-container fluid slot="title-buttons" class="py-1">
      <v-row justify="end">
        <v-btn
          icon
          depressed
          color="primary"
          @click="closeModal"
        >
          <v-icon color="white">close</v-icon>
        </v-btn>
      </v-row>
    </v-container>
    <v-container fluid slot="content">
      <v-row class="mt-5">
        <v-col cols="6" md="4">
          <YearsProgressiveListDropDown
            :year="year"
            :hideDetails="true"
            @yearChange="yearFilterChangeHandler"
          ></YearsProgressiveListDropDown>
        </v-col>
        <v-col cols="6" md="4">
          <FormattedNumberField
            label="Year Goal"
            :value="goalData.goal"
            :hide-details="true"
            prepend-inner-icon="attach_money"
            :readonly="true"
          ></FormattedNumberField>
        </v-col>
        <v-col cols="6" md="4">
          <FormattedNumberField
            label="Month Goal"
            :value="monthGoal"
            :hide-details="true"
            prepend-inner-icon="attach_money"
            :readonly="true"
          ></FormattedNumberField>
        </v-col>
      </v-row>
      <v-row class="mt-10 mb-5">
        <v-col cols="6" sm="3">
          <FormattedNumberField
            label="January"
            :value="revenueLogItems[0].revenue"
            :hide-details="true"
            prepend-inner-icon="attach_money"
            :readonly="true"
            @valueChange="(newValue) => this.revenueLogItems[0].revenue = newValue"
          ></FormattedNumberField>
        </v-col>
        <v-col cols="6" sm="3">
          <FormattedNumberField
            label="February"
            :value="revenueLogItems[1].revenue"
            :hide-details="true"
            prepend-inner-icon="attach_money"
            :readonly="true"
            @valueChange="(newValue) => this.revenueLogItems[1].revenue = newValue"
          ></FormattedNumberField>
        </v-col>
        <v-col cols="6" sm="3">
          <FormattedNumberField
            label="March"
            :value="revenueLogItems[2].revenue"
            :hide-details="true"
            prepend-inner-icon="attach_money"
            :readonly="true"
            @valueChange="(newValue) => this.revenueLogItems[2].revenue = newValue"
          ></FormattedNumberField>
        </v-col>
        <v-col cols="6" sm="3">
          <FormattedNumberField
            label="April"
            :value="revenueLogItems[3].revenue"
            :hide-details="true"
            prepend-inner-icon="attach_money"
            :readonly="true"
            @valueChange="(newValue) => this.revenueLogItems[3].revenue = newValue"
          ></FormattedNumberField>
        </v-col>
        <v-col cols="6" sm="3">
          <FormattedNumberField
            label="May"
            :value="revenueLogItems[4].revenue"
            :hide-details="true"
            prepend-inner-icon="attach_money"
            :readonly="true"
            @valueChange="(newValue) => this.revenueLogItems[4].revenue = newValue"
          ></FormattedNumberField>
        </v-col>
        <v-col cols="6" sm="3">
          <FormattedNumberField
            label="June"
            :value="revenueLogItems[5].revenue"
            :hide-details="true"
            prepend-inner-icon="attach_money"
            :readonly="true"
            @valueChange="(newValue) => this.revenueLogItems[5].revenue = newValue"
          ></FormattedNumberField>
        </v-col>
        <v-col cols="6" sm="3">
          <FormattedNumberField
            label="July"
            :value="revenueLogItems[6].revenue"
            :hide-details="true"
            prepend-inner-icon="attach_money"
            :readonly="true"
            @valueChange="(newValue) => this.revenueLogItems[6].revenue = newValue"
          ></FormattedNumberField>
        </v-col>
        <v-col cols="6" sm="3">
          <FormattedNumberField
            label="August"
            :value="revenueLogItems[7].revenue"
            :hide-details="true"
            prepend-inner-icon="attach_money"
            :readonly="true"
            @valueChange="(newValue) => this.revenueLogItems[7].revenue = newValue"
          ></FormattedNumberField>
        </v-col>
        <v-col cols="6" sm="3">
          <FormattedNumberField
            label="September"
            :value="revenueLogItems[8].revenue"
            :hide-details="true"
            prepend-inner-icon="attach_money"
            :readonly="true"
            @valueChange="(newValue) => this.revenueLogItems[8].revenue = newValue"
          ></FormattedNumberField>
        </v-col>
        <v-col cols="6" sm="3">
          <FormattedNumberField
            label="October"
            :value="revenueLogItems[9].revenue"
            :hide-details="true"
            prepend-inner-icon="attach_money"
            :readonly="true"
            @valueChange="(newValue) => this.revenueLogItems[9].revenue = newValue"
          ></FormattedNumberField>
        </v-col>
        <v-col cols="6" sm="3">
          <FormattedNumberField
            label="November"
            :value="revenueLogItems[10].revenue"
            :hide-details="true"
            prepend-inner-icon="attach_money"
            :readonly="true"
            @valueChange="(newValue) => this.revenueLogItems[10].revenue = newValue"
          ></FormattedNumberField>
        </v-col>
        <v-col cols="6" sm="3">
          <FormattedNumberField
            label="December"
            :value="revenueLogItems[11].revenue"
            :hide-details="true"
            prepend-inner-icon="attach_money"
            :readonly="true"
            @valueChange="(newValue) => this.revenueLogItems[11].revenue = newValue"
          ></FormattedNumberField>
        </v-col>
      </v-row>
    </v-container>
    <v-container fluid slot="buttons" class="pb-0 mb-0">
      <v-row>
        <v-col cols="12">
          <v-btn
            block
            depressed
            outlined
            @click="closeModal"
          >
            Close
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
</DynamicModal>
</template>

<script>
import { DynamicModal } from '@/components/dialogs'
import { RevenueLogInput } from '@/components/revenueData'
import { mapActions } from 'vuex'
import { mapFields } from '@/vueHelpers/vuex'
import { YearsProgressiveListDropDown } from '@/components/years'
import { FormattedNumberField } from '@/components/shared/textFields'

export default {
  components: {
    DynamicModal,
    RevenueLogInput,
    YearsProgressiveListDropDown,
    FormattedNumberField
  },
  data () {
    return {
      showRevenueDetailsModal: false,
      monthGoal: null
    }
  },
  computed: {
    ...mapFields('revenueData', [
      'year',
      'goalData',
      'revenueLogItems'
    ])
  },
  methods: {
    ...mapActions('revenueData', [
      'getRevenueData'
    ]),
    showModal () {
      this.showRevenueDetailsModal = true
    },
    closeModal () {
      this.showRevenueDetailsModal = false
    },
    yearFilterChangeHandler (newValue) {
      this.year = newValue
      this.getRevenueData().then((data) => {
        this.monthGoal = data.goalData.goal / 12
      })
    }
  },
  created () {
    this.year = new Date().getFullYear()
    this.getRevenueData().then((data) => {
      this.monthGoal = data.goalData.goal / 12
    })
  }
}
</script>
